/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Spacing_LabelInputs */



/**
* | output |
* | --- |
* | "Spacing" |
*
* @param {Styles_Spacing_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_spacing_label = /** @type {((inputs?: Styles_Spacing_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Spacing_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Espacement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Abstand")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spaziatura")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Расстояние")
	if (locale === "es") return /** @type {LocalizedString} */ ("Espaciado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("间距")
	if (locale === "ja") return /** @type {LocalizedString} */ ("間隔")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंतर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Espaçamento")
	return /** @type {LocalizedString} */ ("Spacing")
});